import React, { useEffect } from "react";
import { Modal, Input, Select, Form } from "antd";
import { timezones } from "../../../common/Utils";

export const DivisionDlg = ({ save, model, regions, divisionDirectors, visible, saving, close }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(model);
  }, [model]);

  const onSave = () => {
    form.validateFields().then((values) => {
      save(values);
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title="Division"
      visible={visible}
      onOk={onSave}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={close}
    >
      <Form form={form} {...layout} initialValues={{ ...model }}>
        <Form.Item
          label="Division Name"
          name="name"
          rules={[{ required: true, message: "Please input division name!" }]}
        >
          <Input placeholder="Enter division name" />
        </Form.Item>
        <Form.Item label="Region" name="regionId" rules={[{ required: true }]}>
          <Select>
            {regions.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Directors" name="directorIds" rules={[{ required: true }]}>
          <Select mode="multiple">
            {divisionDirectors.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Timezone" name="zoneId">
          <Select showSearch>
            {timezones.map((x) => (
              <Select.Option title={x.val} value={x.key} key={x.key}>
                {x.val}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
